//@flow
import _ from 'lodash';
// app

// rgs-nfd-ui-kit
import { withProps } from './../../../helpers';


type GroupItem = {
	id: string,
	name: string
}

export type DropdownGroup = {
	groupId: string | number;
	groupTitle: string,
	items: GroupItem[]
}

type Options = {
	groups: DropdownGroup[],
	scrollable?: boolean;
	onChange(groupId: string, item: GroupItem): void;
}


export default class DropdownGroupList {
	props: {
		groups: Group[],
		onItemClick(groupId: string, item: GroupItem): void,
		classNames: {[string]: boolean}
	};

	constructor (options: Options) {
		const patchedOptions = this._options = _.defaults(withProps(options), {
			groups: [],
			scrollable: false,
			onChange: _.identity,
		});

		this.props = {
			groups: patchedOptions.groups,
			onItemClick: this.handleClickByItem,
			classNames: {
				'nfd-dropdown-scrollable': patchedOptions.scrollable,
			},
		};
	}

	handleClickByItem = (groupId: string, item: GroupItem): void => {
		this._options.onChange(groupId, item);
	};
}
